import { Viewstates } from "@vattenfall/core";

import { CampaignProductCardFinland } from "./campaign-product-card-finland.model";

export const VIEWSTATES: Viewstates<CampaignProductCardFinland> = <const>{
  loading: {
    action: "loading",
  },
  errorred: {
    action: "errorred",
  },
  completedFixedPrice: {
    action: "completed",
    productId: "1",
    agreementName: "Fixed price",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: false,
    energySourceName: "Aurinko alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
  },
  completedFixedPriceWithDiscount: {
    action: "completed",
    productId: "1",
    agreementName: "Fixed price w. discount",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    discountedMonthlyBaseFee: { value: 2.6, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 12, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: false,
    energySourceName: "Tuulivoima",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
  },
  completedSpotPrice: {
    action: "completed",
    productId: "1",
    agreementName: "Spot price",
    monthlyBaseFee: { value: 4.9, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 0, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: false,
    energySourceName: "Aurinko alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
  },
  completedVariablePrice: {
    action: "completed",
    productId: "1",
    agreementName: "Variable price",
    monthlyBaseFee: { value: 4.9, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 0, unit: "MONTH" },
    productType: "variable",
    hideMonthlyCost: false,
    energySourceName: "Tuulivoima",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
  },
  completedHideMonthlyCost: {
    action: "completed",
    productId: "1",
    agreementName: "Hide monthly cost",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    discountedMonthlyBaseFee: null,
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 12, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: true,
    energySourceName: "Aurinko alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
  },
  completedSpotGuardFee: {
    action: "completed",
    productId: "1",
    agreementName: "Optimi Pörssisähko + hinnankiinnitysturva",
    monthlyBaseFee: { value: 5.95, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5, unit: "EURO_CENT/KWH" },
    spotGuardFee: { value: 4.9, unit: "EURO/MONTH" },
    contractLength: { value: 24, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: true,
  },
};
